import {
  Badge,
  Box,
  Button,
  ButtonGroup,
  DatePicker,
  Filters,
  Icon,
  Tabs,
  InlineStack,
  useIndexResourceState,
  Tooltip,
  Popover,
  OptionList
} from "@shopify/polaris";
import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";
import { ArrowRightIcon,ChevronDownIcon } from "@shopify/polaris-icons";
import "./index.css";
import OrderTrackingTable from "./OrderTrackingTable";
import { useSelector } from "react-redux";
import {
  reqGetOrderNewTrackingList,
  reqPostNewSubscribeChange,
} from "../../../../api";
import SearchLoading from "../../../../components/SearchLoading";
import CommonTableFilterSkeletonList from "../common/CommonTableFilterSkeletonList";
const OrderListFilterBox = ({ toastFun,handleStoreTabChange }) => {
  const [selected, setSelected] = useState(0); //tab 选择状态

  const [requestParams, setRequestParams] = useState({
    page: 1,
    size: 20,
    tag: 1,
    render: 1,
    start_time: "",
    end_time: "",
    order_number: "",
    search_key:["shopify"],
  }); // 请求参数
  const [active, setActive] = useState(null); //搜索 按钮展开
  const [listData, setListData] = useState({}); //列表数据
  const [tabData, setTabData] = useState({}); // 默认存储tab数据
  const [searchLoading, setSearchLoading] = useState(false); // 页面加载
  const [initPage, setInitPage] = useState(true); // 初始化页面
  const [searchBtnLoading, setSearchBtnLoading] = useState(false); // 搜索按钮加载
  const [tabs,setTabs] = useState([
    {
      id: "a1",
      content: "All",
      accessibilityLabel: "All customers",
      panelID: "a1",
    },
    {
      id: "a2",
      content: <span>Under stocking (0)</span>,
      panelID: "a2",
    },
    {
      id: "a3",
      content: <span>Under quality inspection(0)</span>,
      panelID: "a3",
    },

    {
      id: "a4",
      content: <span>Waiting for collection(0)</span>,
      panelID: "a4",
    },
    {
      id: "a5",
      content: <span>In transit(0)</span>,
      panelID: "a5",
    },
    {
      id: "a6",
      content: <span>Out for delivery(0)</span>,
      panelID: "a6",
    },
    {
      id: "a7",
      content: <span>Delivered(0)</span>,
      panelID: "a7",
    },
    {
      id: "a8",
      content: <span>Expired(0)</span>,
      panelID: "a8",
    },
    {
      id: "a9",
      content: <span>Failed attempt(0)</span>,
      panelID: "a9",
    },
  ])
  const plan_level = useSelector(
    (state) => state.languageReducer.subScriptData
  );
  const planCurrent = () => {
    let flag = false;
    if (
      plan_level.bill_level === 2 ||
      plan_level.bill_level === 3 ||
      plan_level.bill_level === 5 ||
      plan_level.level === 2 ||
      plan_level.level === 3 ||
      plan_level.level === 5
    ) {
      flag = true;
    }
    return flag;
  };
  const [upgrageLoading, setUpgrageLoading] = useState(false);

  // 使用 useMemo 缓存可选的订单列表，减少不必要的计算
  const selectableOrders = useMemo(() => {
    if (selected === 0) {
      return listData?.list;
    } else {
      // const filterCondition = ({ product_status, is_publish }) =>
      //   product_status !== 0 && is_publish !== 2;
      // const filteredList = listData?.list?.filter(filterCondition);
      // 如果过滤后为空则回退到原始列表，否则用过滤结果
      return listData?.list;
    }
  }, [listData?.list, selected]); // 明确依赖 listData.list 和 selected
  const { selectedResources, allResourcesSelected, handleSelectionChange } =
    useIndexResourceState(selectableOrders);
  const isMount = useRef(null);

  const dayShow = (isoDate) => {
    // 1. 创建Date对象
    const date = new Date(isoDate);

    const year = date.getFullYear(); // 2025
    let month = date.getMonth() + 1; // 月份从0开始需+1 → 2
    let day = date.getDate(); // 1
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    // 3. 组合成 Y-M-D 格式（自动去除前导零）
    return `${year}-${month}-${day}`;
  };
  const getPageData = (data) => {
    setRequestParams((prev) => {
      getNewData({ ...prev, ...data });
      // 更新 queryParams 状态（确保 setRequestParams 能获得最新数据）
      return { ...prev, ...data };
    });
   
  };
  const getNewData =async (data)=>{
    try {
      let params = {
        ...data,
      };
      if (params.start_time) {
        params.start_time = dayShow(params.start_time);
      }
      if (params.end_time) {
        params.end_time = dayShow(params.end_time);
      }
      params.search_key = params.search_key[0];
      let res = await reqGetOrderNewTrackingList(params);
      if (res.code === "200") {
        setListData(res.data);
        if (Object.values(tabData).length === 0) {
          setTabData(res.data.summary);
          let summary = res.data.summary;
          setTabs([
            {
              id: "a1",
              content: <span>All ({summary.all})</span>,
              accessibilityLabel: "All customers",
              panelID: "a1",
            },
            {
              id: "a2",
              content: ( <Tooltip preferredPosition="above" content={'The order is in stock, estimated to take 1-3 days.'} hasUnderline>
                <span>Under stocking ({summary.under_stocking})</span>
                </Tooltip>
            ),
              panelID: "a2",
            },
            {
              id: "a3",
              content: (  <Tooltip preferredPosition="above" content={'The order is under quality control, estimated to take 1-3 days.'} hasUnderline>
                <span>Under quality inspection({summary.under_quality})</span>
                </Tooltip>
              ),
              panelID: "a3",
            },
    
            {
              id: "a4",
              content: (<Tooltip preferredPosition="above" content={'Order quality inspection and packing completed, waiting for logistics collection.'} hasUnderline>
                <span>Waiting for collection({summary.waiting_logistics})</span>
                </Tooltip>
              ),
              panelID: "a4",
            },
            {
              id: "a5",
              content: <span>In transit({summary.transit})</span>,
              panelID: "a5",
            },
            {
              id: "a6",
              content: <span>Out for delivery({summary.out_for_delivery})</span>,
              panelID: "a6",
            },
            {
              id: "a7",
              content: <span>Delivered({summary.delivered})</span>,
              panelID: "a7",
            },
            {
              id: "a8",
              content: <span>Expired({summary.expired})</span>,
              panelID: "a8",
            },
            {
              id: "a9",
              content: <span>Failed attempt({summary.failed_attempt})</span>,
              panelID: "a9",
            },
          ])
        }
      }
      setInitPage(false);
      setSearchLoading(false);
      setSearchBtnLoading(false);
      handleSelectionChange("page", false, 0);
    } catch (error) {}
  }
  const handleTabChange = (selectedTabIndex) => {
      if (!planCurrent()) {
        return;
      }
      getPageData({
        tag: selectedTabIndex + 1,
        render: 0,
      });
      setSearchLoading(true);
      setSelected(selectedTabIndex);
    };
  useEffect(() => {
    if (!isMount.current) {
      getPageData();
    }
    return () => {
      isMount.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSearchSelect = (value) => {
    setRequestParams((prev) => ({
      ...prev,
      search_key: value,
    }));
  };
  const toggleActive = (id) => () => {
    // 搜索按钮展开和关闭
    setActive((activeId) => (activeId !== id ? id : null));
  };
  const handleFiltersQueryChange = (value) => {
      if (value.length > 20) {
        return;
      }
      if (!planCurrent()) {
        return
      }
      setRequestParams((prev) => ({
        ...prev,
        order_number: value,
      }));
    };

  const currentDate = new Date();
  const [{ month, year }, setDate] = useState({
    month: currentDate.getMonth(),
    year: currentDate.getFullYear(),
  }); // 添加日期
  // 添加日期
  const handleListedDateChange = (value) => {
      if (!planCurrent()) {
        return
      }
      getPageData({
        page:1,
        start_time: value.start,
        end_time: value.end,
      });
    };
  const handleListedDateRemove = (value) => {
      if (!planCurrent()) {
        return
      }
      getPageData({
        page:1,
        start_time: "",
        end_time: "",
      });
    };
  // 月份改变
  const handleMonthChange = useCallback(
    (month, year) => setDate({ month, year }),
    []
  );

  const handleQueryValueRemove = () => {
    if (!planCurrent()) {
      return
    }
    getPageData({
      page:1,
      order_number: "",
    });
    setSearchLoading(true);
  };
  const handleFiltersClearAll = () => {
    if (!planCurrent()) {
      return
    }
    getPageData({
      page:1,
      start_time: "",
      end_time: "",
      order_number: "",
      search_key: ["shopify"],
    });
    setSearchLoading(true);
  };

  const filters = [
    {
      key: "createdDate",
      label: (
        <Box>
          <InlineStack blockAlign="center" gap={200} wrap={false}>
            <span>Start</span>
            <Icon source={ArrowRightIcon} tone="base" />
            <span>End</span>
          </InlineStack>
        </Box>
      ),
      filter: (
        <DatePicker
          month={month}
          year={year}
          onChange={handleListedDateChange}
          onMonthChange={handleMonthChange}
          selected={
            requestParams.start_time && requestParams.end_time
              ? {
                  start: requestParams.start_time,
                  end: requestParams.end_time,
                }
              : undefined
            // 没有选择任何日期时传递 undefined
            // 没有选择任何日期时传递 undefined
          }
          multiMonth
          allowRange
        />
      ),
      pinned: true,
    },
  ];

  const appliedFilters = [];

  if (requestParams.start_time && requestParams.end_time) {
    const key = "createdDate";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, requestParams),
      onRemove: handleListedDateRemove,
    });
  }

  // 升级套餐
  const handleMageUpgrade = async (
    id,
    val,
    email = "",
    social = "",
    am_id = ""
  ) => {
    try {
      let param = {
        package_id: id,
        email: email,
        social: social,
        am_id: am_id,
        is_yearly:listData?.plus_plan?.glasses_level === 1 ? 1 : 0,
      };
      if (val && val !== "") {
        param.remark = val;
      }
      let res = await reqPostNewSubscribeChange(param);
      if (res.code === "200") {
        if (res?.data?.id !== "") {
          if (id !== 0) {
            window.top.location.href = res.data.url;
            toastFun(res.msg);
          }
        }
      } else {
        toastFun("Something wrong");
      }
    } catch (error) {}
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (requestParams.order_number !== "" && !searchLoading) {
        getPageData(selected, {
          page: 1,
          order_number: requestParams.order_number.trim(),
        });
        setSearchLoading(true);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestParams]);
  const pageContent = (
    <Box>
      <Box className="order_list_tab">
        <Tabs
          tabs={tabs}
          selected={selected}
          onSelect={handleTabChange}
        ></Tabs>
      </Box>
      <Box className="product_filter">
        <Filters
          queryPlaceholder={requestParams.search_key[0] === 'shopify' ? "Filter Shopify order":"Filter DSM order"}
          queryValue={requestParams.order_number}
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        >
          <Box paddingInlineStart="0">
            <ButtonGroup variant="segmented">
              <Button
                disabled={!planCurrent()}
                onClick={() => {
                  if (!planCurrent()) {
                    return
                  }
                  setSearchBtnLoading(true);
                  setSearchLoading(true);
                  getPageData({
                    page:1,
                    order_number: requestParams.order_number,
                  });
                }}
                size="micro"
                loading={searchBtnLoading}
              >
                Search
              </Button>
              <Popover
                active={active === "popover1"}
                preferredAlignment="right"
                activator={
                  <Button
                    // disabled={queryParams.q === ''}
                    onClick={toggleActive("popover1")}
                    icon={ChevronDownIcon}
                    size="micro"
                    loading={false}
                  ></Button>
                }
                autofocusTarget="first-node"
                onClose={toggleActive("popover1")}
              >
                <OptionList
                  onChange={handleSearchSelect}
                  options={[
                    { value: "dsm", label: "DSM order number" },
                    { value: "shopify", label: "Shopify order number" },
                  ]}
                  selected={requestParams.search_key || []}
                />
              </Popover>
            </ButtonGroup>
          </Box>
        </Filters>
      </Box>
      <OrderTrackingTable
        planCurrent={planCurrent}
        getPageData={getPageData}
        requestParams={requestParams}
        setSearchLoading={setSearchLoading}
        selected={selected}
        listData={listData}
        loading={false}
        toastFun={toastFun}
        setListData={setListData}
        selectableOrders={selectableOrders}
        selectedResources={selectedResources}
        allResourcesSelected={allResourcesSelected}
        handleSelectionChange={handleSelectionChange}
        handleStoreTabChange={handleStoreTabChange}
      />
      {planCurrent() ? (
        ""
      ) : (
        <Box className="disable-overlay disable-overlay_ordrt_tracking">
          <Box className="disable_overlay_content">
            <Box className="disable_overlay_content_mask"></Box>
            <Box className="disable_overlay_content_box">
              <Box>
                <Box className="disable_overlay_content_price_discount">
                  <Tooltip
                    width={280}
                    content={
                      <Box style={{ width: "280px", padding: "5px 0" }}>
                        {listData.plus_plan?.discount === 1 ? (
                          <Box style={{ marginBottom: "10px" }}>
                            <strong style={{ fontSize: "20px" }}>
                              {" "}
                              ${listData.plus_plan?.price}{" "}
                              <span style={{ fontSize: "13px" }}>/{listData?.plus_plan?.glasses_level === 1 ? "Year" : "Month"}</span>
                            </strong>
                          </Box>
                        ) : (
                          <Box style={{ marginBottom: "10px" }}>
                            <InlineStack gap={100}>
                              <strong style={{ fontSize: "20px" }}>
                                {" "}
                                ${listData.plus_plan?.price}
                                <span style={{ fontSize: "13px" }}>/{listData?.plus_plan?.glasses_level === 1 ? "Year" : "Month"}</span>
                              </strong>{" "}
                              <span
                                style={{
                                  textDecoration: "line-through",
                                  fontSize: "13px",
                                  color: "rgba(181, 181, 181, 1)",
                                }}
                              >
                                ${listData.plus_plan?.money}
                              </span>
                              <Badge tone="success">
                                {parseFloat(
                                  (1 - listData.plus_plan?.discount) * 100
                                ).toFixed(0)}
                                % OFF
                              </Badge>
                            </InlineStack>
                          </Box>
                        )}
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            Access to Winning Products
                          </InlineStack>
                        </Box>
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            60 expert sourcing requests per month{" "}
                          </InlineStack>
                        </Box>
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            15000 Products Import per month{" "}
                          </InlineStack>
                        </Box>
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            Unlimited Orders Fulfillment{" "}
                          </InlineStack>
                        </Box>
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            Vip Shipping Method{" "}
                          </InlineStack>
                        </Box>
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            Order Auto Sourcing{" "}
                          </InlineStack>
                        </Box>
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            Automated Fulfillment{" "}
                          </InlineStack>
                        </Box>
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            Order Tracking{" "}
                          </InlineStack>
                        </Box>
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            Automated Product Pricing{" "}
                          </InlineStack>
                        </Box>
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            Remove China Label{" "}
                          </InlineStack>
                        </Box>
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            24/7 VIP Support{" "}
                          </InlineStack>
                        </Box>
                        <Box
                          style={{
                            color: "rgba(48, 48, 48, 1)",
                            fontSize: "13px",
                            fontWeight: 450,
                          }}
                          className="plan_none_desc"
                        >
                          <InlineStack gap={100}>
                            <span className="subscript_section_price_it_img">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                  fill="#1A1C1D"
                                />
                              </svg>
                            </span>
                            Dedicated Manager{" "}
                          </InlineStack>
                        </Box>
                      </Box>
                    }
                  >
                    <strong>PLUS</strong>
                  </Tooltip>
                </Box>
              </Box>
              <Box className="disable_overlay_content_price_title">
                Unlock the Order tracking for PLUS
              </Box>
              <Box className="disable_overlay_content_price_dsc">
              Track your shipping status and delivery route in real time.
              </Box>
              <Box className="disable_overlay_content_price_button">
                <Button
                  variant="primary"
                  loading={upgrageLoading}
                  onClick={() => {
                    handleMageUpgrade(2);
                    setUpgrageLoading(true);
                    setTimeout(() => {
                      setUpgrageLoading(false);
                    }, 3000);
                  }}
                >
                  Upgrade and Unlock
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
  return (
    <div style={{ position: "relative" }}>
      {initPage ? <CommonTableFilterSkeletonList /> : pageContent}
      {searchLoading && <SearchLoading />}
    </div>
  );
};

function disambiguateLabel(key, value) {
  switch (key) {
    case "createdDate":
      let startDate1 = new Date(value.start_time);
           let endDate1 = new Date(value.end_time);
     
           if (value.start_time === value.end_time) {
             // Single day format
             return (
               <Box>
                 <InlineStack blockAlign="center" gap={200} wrap={false}>
                   <span>
                     {startDate1.toLocaleDateString("en-US", {
                       month: "short",
                       day: "numeric",
                       year: "numeric",
                     })}
                   </span>
                   <Icon source={ArrowRightIcon} tone="base" />
                   <span>End</span>
                 </InlineStack>
               </Box>
             );
           } else {
             const startYear = startDate1.getFullYear();
             const endYear = endDate1.getFullYear();
             // Base format without year
             const baseFormat = { month: "short", day: "numeric" };
     
             if (startYear === endYear) {
               // Same year - show year once at the end
               const startStr = startDate1.toLocaleDateString("en-US", baseFormat);
               const endStr = endDate1.toLocaleDateString("en-US", baseFormat);
               return (
                 <Box>
                   <InlineStack blockAlign="center" gap={200} wrap={false}>
                     <span>{startStr}</span>
                     <Icon source={ArrowRightIcon} tone="base" />
                     <span>
                       {endStr}, {startYear}
                     </span>
                   </InlineStack>
                 </Box>
               );
             } else {
               // Different years - show full date for both
               const fullFormat = { ...baseFormat, year: "numeric" };
               const startStr = startDate1.toLocaleDateString("en-US", fullFormat);
               const endStr = endDate1.toLocaleDateString("en-US", fullFormat);
               return (
                 <Box>
                   <InlineStack blockAlign="center" gap={200} wrap={false}>
                     <span>{startStr}</span>
                     <Icon source={ArrowRightIcon} tone="base" />
                     <span>{endStr}</span>
                   </InlineStack>
                 </Box>
               );
             }
           }
    default:
      return value;
  }
}

export default OrderListFilterBox;
